import { Injectable, NgZone } from '@angular/core';
import * as io from 'socket.io-client';
import { AppService } from './app.service';
import { EventService } from './event.service';
import { AuthService } from '../modules/auth/services/auth.service';
import { Subject } from 'rxjs';
import { UserModel } from '../modules/auth/models/user.model';

@Injectable()
export class SocketService {
  private host: string = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port;
  socket: SocketIOClient.Socket;
  public subject: Subject<any> = new Subject<any>();
  public user: UserModel;

  constructor(public zone: NgZone, private eventService: EventService, private authService: AuthService) {
    if (AppService.getEnvs('socket')) {
      this.host = AppService.getEnvs('socket');

      if (!this.host) {
        return;
      }
    }

    this.connect();

    this.eventService.subscribe('EVENT_USER_INFO_ADDED', (user: UserModel) => {
      this.user = user;
    });

    this.eventService.subscribe('EVENT_USER_INFO_REMOVED', (user: UserModel) => {
      this.user = null;
      this.disconnect();
    });

    this.subject.subscribe((message: any) => {
      if (message.payload && message.payload.type) {
        this.eventService.publish(message.payload.type, message.payload.data);
      }
    });
  }

  public connect() {
    if (this.authService.isAuthenticated()) {
      const socketUrl = this.host + '/messages';
      this.socket = io.connect(socketUrl);
      this.socket.on('message', (message) => this.onMessage(message));

      this.socket.emit('authenticate', {
          username: this.authService.getUsername(),
        }
      );
    }

  }

  public disconnect() {
    this.socket.disconnect();
  }

  public onMessage(message: any) {
    this.zone.run(() => {
      this.subject.next(message);
    });
  }
}
